import { useEffect, useState } from "react";
import api from "../utils/axios";

interface DepositItem {
  transaction_id: number;
  uid: string;
  name: string;
  amount: number;
  status: string;
  transaction_date: string;
  payment_type: "upi" | "crypto" | "Nowpay";
  paymentmethod: string;
  utr_no: string | null;
  txhash: string | null;
  wallet_address: string | null;
  transactionid: string;
}

const ManualDeposit = () => {
  const [tab, setTab] = useState<"upi" | "crypto">("upi");
  const [data, setData] = useState<DepositItem[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchData();
  }, [tab, page]);

  const fetchData = async () => {
    const res = await api.get(
      `/getManualDepositData?page=${page}&limit=10`,
      {
        params: { transactionType: tab, payment_type: tab },
        headers: { Authorization: token },
      }
    );

    setData(res.data.data || []);
    setTotalPages(res.data.totalPages || 1);
  };

  const handleAction = async (
    d: DepositItem,
    isApproved: boolean
  ) => {
    await api.post(
      "/approveRejectManualDeposit",
      {
        trx: d,
        isApproved,
      },
      { headers: { Authorization: token } }
    );

    fetchData();
  };

  return (
    <div className="space-y-6">
      {/* ================= HEADER ================= */}
      <div>
        <h1 className="text-2xl font-bold text-gray-800">
          Manual Deposits
        </h1>
        <p className="text-sm text-gray-500">
          UPI & Crypto approval management
        </p>
      </div>

      {/* ================= TABS ================= */}
      <div className="flex gap-2">
        {["upi", "crypto", "Nowpay"].map((t) => (
          <button
            key={t}
            onClick={() => {
              setTab(t as any);
              setPage(1);
            }}
            className={`px-4 py-2 rounded-lg text-sm font-medium ${
              tab === t
                ? "bg-gray-900 text-white"
                : "bg-gray-100 text-gray-700"
            }`}
          >
            {t === "upi" ? "UPI Deposits" : t === "crypto" ? "Crypto Deposits" : "Nowpay Deposits"}
          </button>
        ))}
      </div>

      {/* ================= TABLE ================= */}
      <div className="bg-white border rounded-2xl shadow-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600">
            <tr>
              <th className="px-4 py-3">#</th>
              <th className="px-4 py-3">User</th>
              <th className="px-4 py-3">Amount</th>

              {tab === "upi" ? (
                <>
                <th className="px-4 py-3">UTR</th>
                  <th className="px-4 py-3">Wallet</th>

                </>
              ) : tab === "Nowpay" ? (
                <>
                  <th className="px-4 py-3">Payment Method</th>
                  <th className="px-4 py-3">Transaction ID</th>
                </>
              ) : (
                <>
                  <th className="px-4 py-3">Network</th>
                  <th className="px-4 py-3">TxHash</th>
                  <th className="px-4 py-3">Wallet</th>
                </>
              )}

              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3">Action</th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan={9}
                  className="py-10 text-center text-gray-500"
                >
                  No records found
                </td>
              </tr>
            ) : (
              data.map((d, i) => (
                <tr
                  key={d.transaction_id}
                  className="border-t hover:bg-gray-50"
                >
                  <td className="px-4 py-3">{i + 1}</td>
                  <td className="px-4 py-3 font-medium">
                    {d.name}
                  </td>
                  <td className="px-4 py-3 font-semibold">
                    {d.payment_type === "upi" ? "₹" : "$"}
                    {d.payment_type === "upi" ? d.amount.toFixed(2) * 95 : d.amount.toFixed(2)}
                  </td>

                  {tab === "upi" ? (
                    <>
                    <td className="px-4 py-3 text-xs">
                      {d.transactionid || "-"}
                    </td>
                    <td className="px-4 py-3 text-xs">
                      {d.utr_no || "-"}
                    </td>
                    </>
                  ) :
                    tab === "Nowpay" ? (
                      <>
                        <td className="px-4 py-3">
                          {d.transaction_type}
                        </td>
                        <td className="px-4 py-3 text-xs">
                          {d.utr_no}
                        </td>
                      </>
                  ) : (
                    <>
                      <td className="px-4 py-3">
                        {d.paymentmethod}
                      </td>
                      <td className="px-4 py-3 text-xs">
                        {d.txhash}
                      </td>
                      <td className="px-4 py-3 text-xs">
                        {d.wallet_address}
                      </td>
                    </>
                  )}

                  <td className="px-4 py-3">
                    <span
                      className={`px-3 py-1 rounded-full text-xs ${
                        d.status === "pending"
                          ? "bg-yellow-100 text-yellow-700"
                          : d.status === "accepted"
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {d.status}
                    </span>
                  </td>

                  <td className="px-4 py-3 text-xs">
                    {new Date(
                      d.transaction_date
                    ).toLocaleString()}
                  </td>

                  <td className="px-4 py-3">
                    {d.status === "pending" && d.payment_type === "upi" && d.payment_type === "crypto" ? (
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleAction(d, true)}
                          className="px-3 py-1 bg-green-600 text-white rounded text-xs"
                        >
                          Accept
                        </button>
                        <button
                          onClick={() => handleAction(d, false)}
                          className="px-3 py-1 bg-red-600 text-white rounded text-xs"
                        >
                          Reject
                        </button>
                      </div>
                    ) : (
                      "—"
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* ================= PAGINATION ================= */}
        <div className="flex justify-between items-center px-4 py-3 border-t">
          <span className="text-sm text-gray-500">
            Page {page} of {totalPages}
          </span>
          <div className="flex gap-2">
            <button
              disabled={page <= 1}
              onClick={() => setPage(page - 1)}
              className="px-4 py-1 border rounded disabled:opacity-40"
            >
              Previous
            </button>
            <button
              disabled={page >= totalPages}
              onClick={() => setPage(page + 1)}
              className="px-4 py-1 border rounded disabled:opacity-40"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualDeposit;
